import axios from 'axios'

const isTestEnv = location.pathname.match('timber-');
const isLocalEnv = location.pathname.match('mkdesigner');
const isStageEnv = location.pathname.match('xstage');

const PRINT_PATH = (isLocalEnv ? 'http://localhost:8089' 
                        : isTestEnv ? 'https://print-test.mhme.nu'
                            : isStageEnv ? 'https://print-stage.mhme.nu'
                                : 'https://print.mhmcdn.com')
                    + '/api/v1';

const getSpecs = (designSize, pages) => {
  return axios.get(`${PRINT_PATH}/quote/specs`, 
    { 
      params: { designSize, pages }, 
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
    }
  );
}

const getQuantities = (designSize, paperSize, pages, paperType, pagination) => {
  return axios.get(`${PRINT_PATH}/quote`, 
    { 
      params: { designSize, paperSize, paperType, pages, pagination }, 
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
    }
  );
}

const getDraftOrder = (locationId) => {
  return axios.get(`${PRINT_PATH}/orders/draft`, 
    { 
      params: { locationId }, 
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
    }
  );
}

const createOrder = (dto) => {
  return axios.post(`${PRINT_PATH}/orders`, dto, 
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const updateOrder = (dto) => {
  return axios.put(`${PRINT_PATH}/orders`, dto, 
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const addOrderItem = (id, itemDto) => {
  return axios.put(`${PRINT_PATH}/orders/${id}/item`, itemDto, 
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const removeItem = (orderId, itemId) => {
  return axios.delete(`${PRINT_PATH}/orders/${orderId}/item/${itemId}`,
  { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } })
}

const getLocationOrders = (locationId) => {
  return axios.get(`${PRINT_PATH}/orders/location`, 
    { 
      params: { locationId }, 
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
    }
  );
}
  
export default {
  getSpecs,
  getQuantities,
  getDraftOrder,
  createOrder,
  updateOrder,
  addOrderItem,
  removeItem,
  getLocationOrders
}
